@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.float-date-picker-content {
  height: 40px;
  padding: 0;
  transition: all 300ms ease;
  background: @float-date-picker--background-color;
  border-radius: 4px;
  border: 1px solid @float-date-picker--border-color;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:focus-within {
    border-color: @float-date-picker--focus-within--border-color;
  }
  &.error {
    border: solid 1px @float-date-picker--error--border-color;
  }
}

.label-and-input {
  position: relative;
  height: 40px;
}

.float-label {
  white-space: nowrap;
}

.date-input {
  top: 10px;
  bottom: 0;
  left: 0;
  border: 0;
  position: absolute;
  z-index: 1;
  width: 120px;
  background: transparent;
  transition: all 400ms ease;
  padding: 0 5px 0 10px;
  color: @float-date-picker--text-color;
  font-size: 14px;
  opacity: 0.2;

  &.has-value {
    opacity: 1;
  }

  &:focus {
    outline: none;
    opacity: 1;
  }
}

.date-picker-wrapper {
  height: 30px;
  margin-right: 4px;
}

.date-picker-button {
  width: 30px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    width: 16px;
    height: 16px;
  }
}
